import helper from '../../preorder/api/helper';
import config from '../../preorder/configs/config';

const AUTH_API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-authCommand`;
const REGISTER_API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-registerCommand`;

const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
};

export const sendVerifyCode = (phone) => helper.post({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    phone,
    command: 'sendVerifyCode',
  },
});

export const phoneAuth = (phone, verifyCode, lineAtId) => helper.post({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    phone,
    verifyCode,
    command: 'auth',
    authMethod: 'phone',
    ...(lineAtId && { lineAtId }),
  },
});

export const lineAuth = ({ code, redirectUri }) => helper.post({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    code,
    redirect_uri: redirectUri,
    command: 'auth',
    authMethod: 'line',
  },
});

export const connectLineAccount = ({ token, redirectUri, code }) => helper.post({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    token,
    redirect_uri: redirectUri,
    code,
    command: 'connectThirdPartyAccount',
    thirdPartyName: 'line',
  },
});

export const connectPhone = (phone, verifyCode) => helper.post({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    phone,
    verifyCode,
    command: 'connectThirdPartyAccount',
    thirdPartyName: 'phone',
  },
});

export const getUserProfile = (token) => helper.get({
  url: AUTH_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    token,
    command: 'getUserProfile',
  },
});

export const register = (
  phoneAuthToken,
  lineAuthToken,
  referrerCustomerId,
  mgmCampaign,
  from,
  birthday,
  gender,
  email,
  providerId
) => helper.post({
  url: REGISTER_API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    birthday,
    email,
    from: from || 'preorder',
    gender,
    lineAuthToken,
    mgmCampaign,
    phoneAuthToken,
    referrerCustomerId,
    providerId,
  },
});
